<template>
    <div class="page-content" id="notifications">
        <Titlebar :incrustation="'fa-exclamation-triangle'">
            <h1>{{ $t('device.titles.notifications.form') }}</h1>
        </Titlebar>
        <div class="row">
            <div class="col-6 notification-preview">
                <!--<IDCard :imageLink="identification.picture" :serial="identification.serial" :title="identification.name" :comment="identification.comment"></IDCard>-->
                <img :src="require('@/assets/img/galaxyS10.png')" style="max-width: 340px;"/>
                <Notification :description="description" :title="title"></Notification>
            </div>
            <div class="col-6" style="height: calc(100% - 40px)">
                <UiCard>
                    <form class="form p-0">
                        <div :class="{error:selectionError}" class="form-row row row-selectors">
                            <div class="selector">
                                <input id="all" type="radio" v-model="selection" value="all"/>
                                <label class="selector-inner" for="all">
                                    <i class="fa fa-mobile-phone"></i>
                                    <span class="label">{{ $t('notification.allDevices') }}</span>
                                    <span class="counter">{{ $tc('notification.countDevices', dati.length, {count: dati.length}) }}</span>
                                </label>
                            </div>
                            <div class="selector">
                                <input id="watching" type="radio" v-model="selection" value="monitoring"/>
                                <label class="selector-inner" for="watching">
                                    <i class="fa fa-eye"></i>
                                    <span class="label">
                                    {{ $t('notification.monitoringDevices') }}
                                        <!-- TOOLTIP -->
                                        <div class="tableColumn-tooltip-wrapper">
                                            <i class="fa fa-info-circle warning-beepiz-remote-monitoring show" style="font-size: 1.2rem; margin-left: 5px; cursor:pointer;"></i>
                                            <div class="tooltip top" style="width: 250px; right:-5px; top:calc(100% + 12px)">
                                            <h5 style="color:#ffc107; font-weight:700">{{ $t('notification.tooltip.title') }}</h5>
                                            {{ $t('notification.tooltip.content') }}
                                            </div>
                                        </div>
                                        <!-- TOOLTIP END -->
                                    </span>
                                    <span class="counter">{{ $tc('notification.countDevices', datistate.length, {count: datistate.length}) }}</span>
                                </label>
                            </div>
                            <div class="selector">
                                <input id="manual" type="radio" v-model="selection" value="manual"/>
                                <label class="selector-inner" for="manual">
                                    <i class="fa fa-list"></i>
                                    <span class="label">{{ $t('notification.manualSelection') }}</span>
                                    <span class="counter">{{ $tc('notification.countDevices', notificationDatis.length, {count: notificationDatis.length}) }}</span>
                                </label>
                            </div>
                        </div>
                        <template v-if="selection == 'manual'">
                            <div class="form-row row">
                                <label class="col-4">{{ $t('planning.form.profile') }}</label>
                                <div class="col-8">
                                    <multiselect
                                        id="planningProfiles"
                                        class="from-top"
                                        v-model="notificationProfiles"
                                        :multiple="true"
                                        :close-on-select="true"
                                        :taggable="false"
                                        placeholder=""
                                        :options="profiles"
                                        label="label"
                                        track-by="profileId"
                                        @blur="modification"
                                        @tag="modification"
                                        @select="modification"
                                        @remove="modification"
                                    >
                                        <template slot="option" slot-scope="{ option }">
                                            <span class="d-inline-flex align-items-center">
                                                <ProfileIcon v-if="option.meta.icon" :icon="option.meta.icon" class="mr-2" />
                                                <span>{{ option.label }}</span>
                                            </span>
                                        </template>
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="d-inline-flex align-items-center">
                                                <ProfileIcon v-if="option.meta.icon" :icon="option.meta.icon" class="mr-2" />
                                                <span>{{ option.label }}</span>
                                            </span>
                                        </template>
                                    </multiselect>
                                    <span class="offset-4 form-input-error" v-show="showErrors['label'] && errors.has('label')"
                                        @click="hideError('label')">{{ errors.first('label') }}</span>
                                </div>
                            </div>
                            <div class="form-row row">
                                <label class="col-4">{{ $t('planning.form.group') }}</label>
                                <div class="col-8">
                                    <multiselect
                                        id="planningGroups"
                                        class="from-top"
                                        v-model="notificationGroups"
                                        :multiple="true"
                                        :close-on-select="true"
                                        :taggable="false"
                                        placeholder=""
                                        :options="groups"
                                        label="label"
                                        track-by="id"
                                        @blur="modification"
                                        @tag="modification"
                                        @select="modification"
                                        @remove="modification"
                                    >
                                        <template slot="option" slot-scope="{ option }">
                                            <span>{{ option.label }}</span>
                                        </template>
                                        <template slot="tag" slot-scope="{ option }">
                                            <span>{{ option.label }}</span>
                                        </template>
                                    </multiselect>
                                    <span class="offset-4 form-input-error" v-show="showErrors['label'] && errors.has('label')"
                                    @click="hideError('label')">{{ errors.first('label') }}</span>
                                </div>
                            </div>
                            <div class="form-row row">
                                <label class="col-4">{{ $t('planning.form.dati') }}</label>
                                <div class="col-8">
                                    <multiselect
                                        id="planningDatis"
                                        class="from-top"
                                        v-model="notificationDatis"
                                        :multiple="true"
                                        :close-on-select="true"
                                        :taggable="false"
                                        placeholder=""
                                        :options="datis"
                                        label="label"
                                        track-by="id"
                                        @blur="modification"
                                        @tag="modification"
                                        @select="modification"
                                        @remove="modification"
                                    >
                                        <template slot="option" slot-scope="{ option }">
                                            <span>{{ option.label }}</span>
                                        </template>
                                        <template slot="tag" slot-scope="{ option }">
                                        <span class="tag-content">
                                            {{ option.label || option.name }}
                                        </span>
                                            <template v-if="option.from">
                                                <div class="tooltip bottom" style="width: 140px;bottom: calc(100% + 5px); right: calc(50% - 14px);">
                                                    {{ option.fromObject.name || option.fromObject.label }}
                                                </div>
                                            </template>
                                        </template>
                                    </multiselect>
                                    <span class="offset-4 form-input-error" v-show="showErrors['label'] && errors.has('label')"
                                        @click="hideError('label')">{{ errors.first('label') }}</span>
                                </div>
                            </div>
                            <div class="form-separator"></div>
                        </template>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('notification.title') }}</label>
                            <input :data-vv-as="$t('notification.title')" class="form-input col"
                                data-vv-rules="required" maxlength="255" name="title" type="text"
                                v-model="title" v-validate/>
                            <span @click="hideError('title')" class="form-input-error"
                                v-show="showErrors['title'] && errors.has('title')">{{ errors.first('title') }}</span>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('notification.description') }}</label>
                            <textarea :data-vv-as="$t('notification.description')" class="form-input col"
                                    data-vv-rules="required" maxlength="250" name="description"
                                    v-model="description" v-validate></textarea>
                            <span class="text-counter">{{ description.length }}/250</span>
                            <span @click="hideError('description')"
                                class="form-input-error"
                                v-show="showErrors['description'] && errors.has('description')">{{ errors.first('description') }}</span>
                        </div>
                        <div class="form-separator"></div>
                        <div class="form-row">
                            <div class="col-12">
                                <label>{{ $t('notification.sending_type') }}</label>
                                <UiSwitch 
                                    :value="!scheduler"
                                    @input="setScheduler(!$event)"
                                    :labelYes="$t('notification.sendNow')"
                                    :labelNo="$t('notification.sendSchedule')"
                                />
                            </div>
                        </div>
                        <div v-if="scheduler" class="form-row" >
                            <div class="col-12">
                                <label>{{ $t('notification.sending_timing') }}</label>
                                <div>
                                    <DatePicker
                                        v-model="scheduleDate"
                                        :min="nowDate"
                                        :position="{v:'bottom',h:'left'}"
                                    />
                                    <span class="mx-2">{{ $t('global.at') }}</span>
                                    <ClockPicker v-model="scheduleTime" :position="{v:'bottom',h:'left'}" />
                                </div>
                            </div>
                        </div>
                    </form>
                </UiCard>
                <Toolbar class="justify-content-start flex-row-reverse">
                    <Btn :class="['primary ',{disabled:validIsDisabled}]" @click.native.prevent="validForm">
                        {{ $t('global.send') }}
                    </Btn>
                    <Btn :class="''">
                        <span @click="goBack()">{{ $t('global.cancel') }}</span>
                    </Btn>
                    <Btn :class="'default'">
                        <router-link to="/parameters/notifications/" tag="span"><span>{{ $t('device.notifications.btns.list') }}</span>
                        </router-link>
                    </Btn>
                </Toolbar>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios';
    import API from '@/services/API.js';
    import Utils from '@/services/utils.js'
    import FormUtils from '@/services/form.js';
    import moment from 'moment'

    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import UiCard from "@/components/ui/Card";
    import Btn from "@/components/ui/Button";
    import UiSwitch from "@/components/ui/Switch";
    import Notification from '@/components/devices/Notification'
    import Multiselect from '@/components/ui/Multiselect'

    import ClockPicker from '@/components/ui/datetime/TimePicker'
    import DatePicker from '@/components/ui/datetime/DatePicker'

    import _concat from 'lodash/concat'
    import _filter from 'lodash/filter'
    import _map from 'lodash/map'
    import _findIndex from 'lodash/findIndex'
    import ProfileIcon from '@/components/profiles/ProfileIcon';
    import {useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'DevicesNotifications',
        components: {
            Titlebar,
            Toolbar,
            UiCard,
            Btn,
            UiSwitch,
            Multiselect,    
            Notification,
            ClockPicker,
            DatePicker,
            ProfileIcon
        },
        computed: {
            validIsDisabled() {
                if (this.title === '') {
                    return true
                }

                if (this.description === '') {
                    return true
                }
                if (this.selection === 'all') {
                    return this.dati.length === 0
                } else if (this.selection === 'monitoring') {
                    return this.datistate.length === 0
                } else if (this.selection === 'manual') {
                    return this.notificationDatis.length === 0 || (this.scheduler && (!this.scheduleDate || !this.scheduleTime))
                }

                return true
            },
            nowDate(){
                return moment()
            }
        },
        data: () => ({
            title: "",
            description: "",
            selection: "",
            showErrors: {
                title: false,
                description: false
            },
            selectionError: false,
            config: {
                perpage: 99999,
                fields: [],
                page: 1,
                filter: {
                    like: [],
                    equals: []
                },
                sort: ['+name']
            },
            dati: [],
            datistate: [],
            notificationProfiles: [],
            notificationGroups: [],
            notificationDatis: [],
            profiles: [],
            groups: [],
            datis: [],
            pollingInterval: null,
            scheduler: false,
            scheduleDate: null,
            scheduleTime: null
        }),

        methods: {
            goBack(){
              this.$router.go(-1)
            },
            validForm: function () {
                FormUtils.hideAllErrors(this);
                if (this.selection === "") {
                    this.selectionError = true
                } else {
                    this.$validator.validateAll().then(() => {
                        this.saveForm();
                    }).catch((error) => {
                        FormUtils.showAllErrors(this);
                    });
                }
            },
            saveForm: function () {
                window.Vfc.$refs.loading.show();

                let datiIds = []
                if (this.selection === 'all') {
                    datiIds = this.dati.map(item => {
                        return item.id
                    })
                } else if (this.selection === 'monitoring') {
                    datiIds = this.datistate.map(item => {
                        return item.dati.id
                    })
                }

                let notification = {
                    title: this.title,
                    content: this.description,
                    dati_ids: datiIds,
                    datisToAttach: this.notificationDatis.filter(item => { return item.from === null }).map(item => { return item.id }),
                    groupsToAttach: this.notificationGroups.map(item => { return item.id }),
                    profilesToAttach: this.notificationProfiles.map(item => { return item.profileId })
                }

                if(Array.isArray(notification.datisToAttach) && notification.datisToAttach.length === 0) {
                  notification.datisToAttach = notification.dati_ids
                }

                if(this.scheduler){
                    let date = this.scheduleDate.clone()
                    let tempTime = this.scheduleTime.split(':')
                    date.hour(tempTime[0])
                    date.minute(tempTime[1])
                    date.second(0)
                    notification.theoric_sending_date = date.format('YYYY-MM-DD HH:mm:ss')
                }

                axios.post(API.endpoints.datis.notifications, notification)
                    .then(response => {
                        window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                        window.Vfc.$refs.loading.hide();
                        window.V._router.push('/parameters/notifications');
                    })
                    .catch(error => {
                        if (error.response != null) {
                            var errorBag = this.$validator.errorBag;
                            if (error.response.status == 422) {
                                FormUtils.handleErrors(errorBag, error.response.data.message)
                            }
                            FormUtils.showAllErrors(this);
                        } else {
                        }
                        window.Vfc.$refs.loading.hide();
                    })
            },
            hideError: function (key) {
                FormUtils.hideError(this, key);
            },
            loadData: function () {
                axios.get(API.endpoints.datis.index + API.constructQueryParams(this.config))
                    .then(response => {
                        this.dati = response.data.data
                        axios.get(API.endpoints.datis.monitoring)
                            .then(responseState => {
                                this.datistate = responseState.data.data
                                this.loadProfiles()
                            })
                    })

                this.pollingInterval = setInterval(() => {
                    axios.get(API.endpoints.datis.monitoring)
                        .then(responseState => {
                            this.datistate = responseState.data.data
                        })
                }, 10000)
            },
            loadProfiles: function () {
                axios.get(API.endpoints.profiles.index + API.constructQueryParams({perpage: 9999999999999}))
                    .then(response => {
                        this.profiles = response.data.data;
                        for (var i = 0; i < this.profiles.length; i++) {
                            this.profiles[i].label = this.profiles[i].meta.name

                            //this.profiles[i].nbDatis = this.profiles[i].datis.length
                        }
                        this.loadGroups();
                    })
            },
            loadGroups: function () {
                axios.get(API.endpoints.groups.index + API.constructQueryParams({perpage: 9999999999999}))
                    .then(response => {
                        this.groups = response.data.data;
                        for (var i = 0; i < this.groups.length; i++) {
                            this.groups[i].label = this.groups[i].name
                            //this.groups[i].nbDatis = this.groups[i].datis.length
                        }
                        this.loadDevices();
                    })
            },
            loadDevices: function () {
                axios.get(API.endpoints.datis.index + API.constructQueryParams({perpage: 9999999999999}))
                    .then(response => {
                        this.datis = response.data.data;
                        for (var i = 0; i < this.datis.length; i++) {
                            this.datis[i].label = this.datis[i].name
                        }

                        this.datis = this.datis.map(dati => {
                            return {
                                id: dati.id,
                                label: dati.name,
                                groupId: dati.groupId,
                                profile: dati.profile,
                                from: null
                            }
                        })
                        window.Vfc.$refs.loading.hide();
                    })
            },
            resetForm: function () {
                this.title = ""
                this.description = ""
                this.selection = ""
            },
            mergeDatis(firstLoad) {
                let datis = []

                Vue.nextTick(() => {
                    this.notificationProfiles.forEach(profile => {
                        datis = _concat(datis, _map(_filter(this.datis, dati => {
                            if(dati.profile) {
                                return dati.profile.id == profile.profileId
                            }
                        }),dati => {
                            return {
                                id: dati.id,
                                label: dati.label,
                                from: 'profile',
                                fromObject: profile,
                                className: 'readonly',
                                readonly: true
                            }
                        }))
                    })

                    this.notificationGroups.forEach(group => {
                        datis = _concat(datis, _map(_filter(this.datis ,dati => {
                            if(dati.groupId) {
                                return dati.groupId == group.id
                            }
                        }),dati => {
                            return {
                                id: dati.id,
                                label: dati.label,
                                from: 'group',
                                fromObject: group,
                                className: 'readonly',
                                readonly: true
                            }
                        }))
                    })

                    datis = _concat(datis, _filter(this.notificationDatis, dati => {
                        return dati.from === null
                    }))

                    datis = _filter(datis, (dati, index, self) =>
                        index === _findIndex(self, (t) => (
                            t.id === dati.id
                        ))
                    )

                    Vue.set(this,'notificationDatis',datis)
                })

            },
            modification: function (section,key) {
                this.mergeDatis(false)
            },
            setScheduler: function(val) {
                this.scheduler = val
            }
        },

        destroyed() {
            clearInterval(this.pollingInterval)
        },

        mounted() {
            if (!useDvFlagAccess('beepiz-notification-can:read')) {
                this.$router.push({ name: 'AccessDenied', params: { slug: 'sendNotifications'} })
            } else {
                this.loadData();
                this.scheduleDate = this.nowDate
                this.scheduleTime = moment().format('HH:mm')
            }
        }
    }
</script>

